const ALL_EXPERIMENT_GROUPS = "All";
const ALL_EXPERIMENTS = "all";
const INVALID_DATE = "Invalid date";
const DEFAULT_SEARCH_PAGE_SIZE = 1e3;
const EXPERIMENTATION_GROUP_URL_PARAM = "experimentationgroup";
export {
  ALL_EXPERIMENTS,
  ALL_EXPERIMENT_GROUPS,
  DEFAULT_SEARCH_PAGE_SIZE,
  EXPERIMENTATION_GROUP_URL_PARAM,
  INVALID_DATE
};
//# sourceMappingURL=FeatureSearchConstants.js.map
